import React from 'react';
import { X } from 'lucide-react';
import Tooltip from '../../ui/Tooltip';
import { formatChip } from './registry';

/** One active filter. The body reopens the panel at this field; × removes just this filter. */
const FilterChip = ({ field, value, onEdit, onRemove }) => {
    const text = formatChip(field, value);
    return (
        <span className="inline-flex max-w-full items-center rounded-full border border-primary-200 bg-primary-50 text-sm text-primary-900">
            <button
                type="button"
                onClick={onEdit}
                title={`${field.label}: ${text} — edit`}
                className="flex min-w-0 items-center gap-1 rounded-l-full py-1 pl-3 pr-1.5 outline-none hover:bg-primary-100 focus-visible:ring-2 focus-visible:ring-primary-300"
            >
                <span className="shrink-0 text-primary-700">{field.label}:</span>
                <span className="truncate font-medium">{text}</span>
            </button>
            <Tooltip label="Remove filter">
                <button
                    type="button"
                    onClick={onRemove}
                    aria-label={`Remove ${field.label} filter: ${text}`}
                    className="mr-0.5 grid h-6 w-6 shrink-0 place-content-center rounded-full text-primary-700 outline-none hover:bg-primary-100 hover:text-primary-900 focus-visible:ring-2 focus-visible:ring-primary-300"
                >
                    <X className="h-3.5 w-3.5" aria-hidden="true" />
                </button>
            </Tooltip>
        </span>
    );
};

export default FilterChip;
